import React, { useContext } from "react";
import { Grid } from "@material-ui/core";
import AppBar from "../components/headerNav/HeaderNav";
import _ from "lodash";
import DashboardToolBox from "../components/toolbox/ToolBox";
import Header from "../components/header/Header";
import { TableViewSelectionContextProvider } from "../context/TableViewSelectionContext";
import JobTable from "../components/dashboard/JobTable";
import RequestTable from "../components/dashboard/RequestTable";
import { DashboardContextProvider } from "../context/DashboardContext";
import CustomFilters from "../components/filters/CustomFilters";
import PresetFilter from "../components/filters/PresetFilters";
import { UserContext } from "../context/UserContext";
import "../styles/dashboard.scss";
import { Container } from "react-bootstrap";
import SnackBar from "../components/snackbar/SnackBar";
import Footer from "../components/footer/Footer";
import { UserRoles } from "../constants/UserRoles";
import CookieConsentBanner from "../components/cookie-consent/CookieConsentBanner";

export const jobHeaders = (role) => {  
  const headersPart1 = [{ label: "", type: "collapse-button", fields: "", width: "4%" },
  {
    label: "Request Name",
    value: "requestName",
    type: "requestId",
    fields: ["requestSummary.name"],
    width: "13%",
    title: "Click on the below Request Name to view the Request Summary",
  },
  {
    label: "Requestor",
    value: "requestor",
    type: "text",
    fields: ["requestSummary.requestorFullName"],
    width: "9%",
  },
  {
    label: "Department",
    value: "department",
    fields: ["requestSummary.deptName"],
    width: "11%",
  },
  {
    label: "Job ID",
    value: "jobId",
    type: "jobId",
    fields: ["jobId"],
    title: "Click on the below JobID to view the Job Summary",
    width: "8%",
    iconName: "information",
  },
  {
    label: "Job Type",
    value: "jobType",
    type: "idType",
    fields: ["jobType"],
    width: "8%",
  },
  {
    label: (
      <>
        <div>Source</div>
        <div>Location</div>
      </>
    ),
    value: "sourceType",
    specialHandling: true,
    fields: ["source.sourceLocation.locationSubType"],
    width: "8%",
  },{
    label: "Due Date",
    type: "dateTime",
    value: "dueDate",
    fields: ["dueDate", "dueTime"],
    width: "10%",
    icon: {
      iconType: "editDuedate",
      icon: "calendar",
      actionType: "Popover",
      action: "dueDate",
    },
    iconName: "calendar",
    title: "Click on below fields to edit due date",
  }];
  const headersPart2 = [{
    label: "Assigned to",
    value: "assignedTo",
    fields: ["assignedTo.fullName"],
    width: "11%",
    icon: {
      iconType: "editAssignee",
      icon: "reassign-active",
      actionType: "Popover",
      action: "assignTo",
    },
    iconName: "reassign-active",
    title: "Click on below fields to edit assignee",
  }];
  const headersPart3=[{
    label: "Status",
    value: "status",
    type: "status",
    fields: ["status"],
    width: "9%",
    icon: {
      iconType: "editStatus",
      icon: "status",
      actionType: "Popover",
      action: "statusChange",
    },
    iconName: "status",
    title: "Click on below fields to edit job status",
  },
  {
    label: (
      <>
        <div>Date</div>
        <div>Submitted</div>
      </>
    ),
    value: "dateSubmitted",
    type: "dateSubmitted",
    fields: ["requestSummary.submittedDate"],
    width: "9%",
  }
  ];
  const headersPart4 = [
  {
    label: "Pre Air",
    value: "preAir",
    type: "preAir",
    fields: ["source.preAir"],
    width: "6%",
  },{
    label: (
      <>
        <div>Date/Time</div>
        <div>Completed</div>
      </>
    ),
    value: "dateTimeCompleted",
    type: "dateTimeCompleted",
    fields: ["completedDate"],
    width: "8%",
  }];
  const headersPart5 = [{
    label: role === UserRoles.CR_API ? "Content Type" : (
      <>
        <div>Content</div>
        <div>Type</div>
      </>
    ),
    value: "contentType",
    type: "contentType",
    fields: ["contentType"],
    width: "9%"
  }]

  if (role === UserRoles.CR_API || role === UserRoles.MEDIAREQUEST) {
    return [...headersPart1, ...headersPart5,
    ...headersPart3]
  } else if (role === UserRoles.SUPERADMIN || role === UserRoles.GLOBALADMIN || role === UserRoles.REQUESTOR || role === UserRoles.OPS) {
    return [...headersPart1, ...headersPart5, ...headersPart2, ...headersPart3,
    ...headersPart4]
  }
  return [...headersPart1,...headersPart2,...headersPart3,
  ...headersPart4]
} 

const getRequestHeaders = (role) => {

  const reqNameInfoText = 'Click on the below Request Name to view the Request Summary';
  const titleRequestName = _.includes(['cr_api', 'adminwithreadaccess', 'mediarequest'], role) ? reqNameInfoText : `${reqNameInfoText}/Edit Draft`;
  const reqIdInfoText = 'Click on the below Request ID to view the Request Summary';
  const titleRequestId = _.includes(['cr_api', 'adminwithreadaccess', 'mediarequest'], role) ? reqIdInfoText : `${reqIdInfoText}/Edit Draft`;

  const requestHeaders1 = [
    { label: "", type: "delete-draft-button", fields: "", width: "2%" },
    {
      label: "Request Name",
      value: "requestName",
      type: "requestId",
      fields: ["name"],
      width: "13%",
      title: titleRequestName,
    },
    {
      label: "Requestor",
      value: "requestor",
      type: "text",
      fields: ["requestor.fullName"],
      width: "8%",
    },
    {
      label: "Department",
      value: "department",
      fields: ["requestor.deptName"],
      width: "9%",
    },
    {
      label: "Request ID",
      value: "requestId",
      type: "requestId",
      fields: ["requestId"],
      width: "8%",
      title: titleRequestId,
    },
    {
      label: "Job Type",
      value: "jobType",
      type: "idType",
      fields: ["jobType"],
      width: "8%",
    },
    {
      label: (
        <>
          <div>Source</div>
          <div>Location</div>
        </>
      ),
      value: "sourceType",
      specialHandling: true,
      fields: ["sourceType"],
      width: "9%",
    },
    {
      label: "Due Date",
      type: "dateTime",
      value: "dueDate",
      fields: ["rolledUpDate", "rolledUpTime"],
      width: "9%",
    }
  ];
  const requestHeaders2 = [{
    label: "Status",
    value: "status",
    type: "status",
    fields: ["rolledUpStatus"],
    width: "8%",
  },
  {
    label: (
      <>
        <div>Date</div>
        <div>Submitted</div>
      </>
    ),
    value: "dateSubmitted",
    type: "dateSubmitted",
    fields: ["submittedDate"],
    width: "8%",
  },
  {
    label: "Job Count",
    value: "jobCount",
    fields: ["totalJobCount"],
    width: "8%",
  },{
    label: (
      <>
        <div>Date/Time</div>
        <div>Completed</div>
      </>
    ),
    value: "rolledUpCompletedDate",
    type: "rolledUpCompletedDate",
    fields: ["rolledUpCompletedDate"],
    width: "8%",
  }];
  const crHeader = [{ 
    label: "Content Type",
    value: "contentType",
    fields: ["contentType"],
    width: "9%",
  }];

  if (role === UserRoles.CR_API || role === UserRoles.SUPERADMIN || role === UserRoles.GLOBALADMIN || role === UserRoles.MEDIAREQUEST || role === UserRoles.REQUESTOR || role === UserRoles.OPS) {
    return [...requestHeaders1, ...crHeader, ...requestHeaders2];
  }
  return [...requestHeaders1, ...requestHeaders2];
}
const selectedJobs = [];
const dataChanged = "Jobs";

const Dashboard = () => {
  const { userRole } = useContext(UserContext);

  return _.isEmpty(userRole) ? null : (
    <Container fluid className="dashboardContainer">
      <TableViewSelectionContextProvider>
        <Grid container>
          <DashboardContextProvider>
            <AppBar />
              <>
                <Grid item xs={8} style={{ height: "100px" }}>
                  <Header headingText="Dashboard" />
                </Grid>
                <Grid item xs={4} className="toolContext">              
                  <DashboardToolBox
                    mode={"dashboard"}
                    Selected={selectedJobs.length > 0}
                    selectedItems={selectedJobs}
                  ></DashboardToolBox>
                </Grid>
                <Grid item xs={12}>
                  <CustomFilters />
                  <PresetFilter />
                </Grid>
                <JobTable headers={jobHeaders(userRole)} dataChanged={dataChanged} />
                <RequestTable headers={getRequestHeaders(userRole)} dataChanged={dataChanged} />
                <SnackBar />
              </>
            <Footer />
            <CookieConsentBanner />
          </DashboardContextProvider>
        </Grid>
      </TableViewSelectionContextProvider>
    </Container>
  );
};

export default Dashboard;
